import { useId, useMemo, useState } from 'react';
import { searchArtTaxonomy } from '../lib/taxonomySearch';

export default function ArtCategorySearch({ onSelect, selected = [], label = 'Search all art categories and specialisations', allowCustom = true }) {
  const [query, setQuery] = useState('');
  const [limit, setLimit] = useState(30);
  const id = useId();
  const results = useMemo(() => searchArtTaxonomy(query), [query]);
  return <div className="min-w-0 rounded-xl border border-orange-200 bg-white p-3">
    <label htmlFor={id} className="block text-sm font-semibold text-gray-900">{label}</label>
    <input id={id} type="search" value={query} onChange={event => { setQuery(event.target.value); setLimit(30); }}
      placeholder="Try charcoal, vlogger, model, film director…" autoComplete="off"
      className="mt-2 w-full rounded-lg border border-gray-300 p-3 text-base text-gray-900 focus:border-orange-500" />
    <p className="mt-1 text-xs text-gray-600">Search any level. Each result shows where it belongs.</p>
    {query.trim() && <>
      <p role="status" className="mt-2 text-sm text-gray-600">{results.length ? `${results.length} matches` : `No matches. Try another spelling${allowCustom ? ' or enter your art form under Other' : ''}.`}</p>
      <ul className="mt-2 max-h-72 overflow-y-auto overscroll-contain" aria-label="Art category search results">
        {results.slice(0, limit).map(entry => <li key={entry.key}>
          <button type="button" onClick={() => onSelect(entry)} aria-pressed={selected.includes(entry.label)}
            className="w-full rounded-lg px-3 py-2 text-left text-sm hover:bg-orange-50 focus:bg-orange-50 focus:outline-orange-500">
            <span className="font-semibold text-gray-900">{entry.label}{selected.includes(entry.label) ? ' ✓' : ''}</span>
            <span className="block break-words text-xs text-gray-600">{entry.path.join(' → ')}</span>
          </button>
        </li>)}
      </ul>
      {results.length > limit && <button type="button" className="mt-2 text-sm font-semibold text-orange-700 underline" onClick={() => setLimit(limit + 30)}>Show more matches</button>}
      <button type="button" className="ml-3 mt-2 text-sm text-gray-600 underline" onClick={() => setQuery('')}>Clear search</button>
    </>}
  </div>;
}
